import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { Loader } from "@devhop/ui";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export function AuthLayout() {
  const { isLoading, isAuthenticated } = useAuthState();
  const navigate = useNavigate({ from: "/auth" });

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: "/app/dashboard" });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="flex min-h-svh items-center justify-center bg-background">
        <Loader />
      </div>
    );
  }

  return (
    <div className="min-h-svh bg-background">
      {/* Subtle grid pattern - freedom® minimal */}
      <div
        className="pointer-events-none fixed inset-0 bg-[linear-gradient(to_right,oklch(0.97_0_0)_1px,transparent_1px),linear-gradient(to_bottom,oklch(0.97_0_0)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,black_70%,transparent_100%)]"
        aria-hidden
      />
      <div className="relative flex min-h-svh flex-col items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-[28rem]">
          {/* Portal branding */}
          <div className="mb-8 flex flex-col items-center text-center">
            <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-lg border border-border bg-card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-6 w-6 text-foreground"
                aria-hidden
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <h1 className="font-semibold text-xl tracking-tight text-foreground">
              ຝ່າງ PORTAL
            </h1>
            <p className="mt-1 text-sm text-muted-foreground">
              Employee Self-Service
            </p>
          </div>
          <Outlet />
        </div>
        <p className="mt-8 text-center text-xs text-muted-foreground">
          ຂໍ້ມູນ ແລະ ບໍລິການດ້ວຍຕົນເອງ — ລາວ
        </p>
      </div>
    </div>
  );
}
